import { render } from "./LinkedProductionOrder.vue?vue&type=template&id=027a3358&scoped=true"
import script from "./LinkedProductionOrder.vue?vue&type=script&lang=js"
export * from "./LinkedProductionOrder.vue?vue&type=script&lang=js"

import "./LinkedProductionOrder.vue?vue&type=style&index=0&id=027a3358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027a3358"]])

export default __exports__